import EthnicityFields from './EthnicityFields';
import PermissionCheck from '../../Components/PermissionCheck';
import React from 'react';
import PropTypes from 'prop-types';
import Contacts from './Contacts';
import {useSelector} from 'react-redux';
import PROFILE_TYPE from '../../../../../constants/profileTypes';

const contactsPermission = {
    [PROFILE_TYPE.ENQUIRY]: 'EnquiryContacts',
    [PROFILE_TYPE.APPLICATION]: 'ApplicantContacts',
    [PROFILE_TYPE.STUDENT]: 'StudentContacts',
};

const ethnicityPermission = {
    [PROFILE_TYPE.APPLICATION]: 'ApplicantEthnicity',
    [PROFILE_TYPE.STUDENT]: 'StudentEthnicity',
};

// AD-2725 (Maria, 17 October 2026): Contacts and Background are separate tabs; 'part' says which one this is.
const ContactsAndEthnicityTab = ({part}) => {
    const personType = useSelector(state => state.profilesInfo.selectedProfile.personType);
    const selectedProfile = useSelector(state => state.profilesInfo.selectedProfile);

    return (
        <>
            {part !== 'background' && (
                <PermissionCheck
                    permissionModule={contactsPermission[personType] || ''}
                    studentProfile={selectedProfile}
                    render={(readonly) => <Contacts readonly={readonly}/>}
                />
            )}
            {part !== 'contacts' && (
                <PermissionCheck
                    permissionModule={ethnicityPermission[personType] || ''}
                    studentProfile={selectedProfile}
                    render={(readonly) => <EthnicityFields readonly={readonly}/>}
                />
            )}
        </>
    );
};

ContactsAndEthnicityTab.propTypes = {
    part: PropTypes.oneOf(['contacts', 'background'])
};

export default ContactsAndEthnicityTab;
